import React, { useEffect, useState } from 'react';
import axios from 'axios';

import { DownCarotIcon } from '../../components/icons';
import StatusLabel from '../../components/StatusLabel';
import { Order, Search, Document, Property } from '../types';
import { SearchInfo, DropdownOuter } from './styles';
import SearchActionsDropdown from './SearchActionsDropdown';
import { Checkbox } from 'semantic-ui-react';
import { Modal } from 'semantic-ui-react';

interface PropTypes {
  searchType: string;
  dateOrdered: string;
  status?: string;
  fee?: number;
  order?: Order;
  searchId: number;
  documentsSearches: Document[];
  sdaOpen: any;
  updateSearch: (searchType: any, note: string) => Promise<void>;
  searchesToDownload: any;
  handleSearchCheckChange: any;
  completedStatus: boolean;
  closeDropdownForSearch: (searchId: number) => void;
  openDropdownForSearch: (searchId: number) => void;
  closeAllSearches: () => void;
  searchIdsOpen: number[];
  downloadSda: () => void;
  download: any;
  searchTypeId: number;
}

const SearchCard = (props: PropTypes) => {
  // const [openDropdown, setOpenDropdown] = useState(false);
  const showDropdown = props.status === 'Completed' || props.status === 'SDA Requested';
  const [preview, setPreview] = useState({ iframeOpen: false, iframeUrl: '' });
  const [searchDocId, setSearchDocId] = useState(null);
  const dropdownOpen = props.searchIdsOpen.includes(props.searchId);
  const viewPdf = (url: string) => {
    setPreview({ iframeOpen: true, iframeUrl: url });
  };
  useEffect(() => {
    if (props.status === 'Completed') {
      axios
        .get(`/api/clientDownload/getSearchDocId/${props.searchId}`)
        .then(({ data }) => setSearchDocId(data?.documentId));
    }
  }, []);

  return (
    <div style={{ position: 'relative' }}>
      {preview.iframeOpen && (
        <Modal
          open={preview.iframeOpen}
          style={{ zIndex: 500, borderRadius: 5 }}
          onClose={() => setPreview({ iframeOpen: false, iframeUrl: '' })}
        >
          {/* <Iframe
              url={preview.iframeUrl}
              onClose={() => setPreview({ iframeOpen: false, iframeUrl: '' })}
              width={'650px'}
            ></Iframe> */}
          <iframe title="doc-preview" src={preview.iframeUrl} style={{ height: 800, width: '100%' }}></iframe>
        </Modal>
      )}
      <div style={{ position: 'absolute', top: 24 }}>
        {props.completedStatus && (
          <Checkbox
            disabled={props.status !== 'Completed'}
            checked={props.searchesToDownload.includes(props.searchId)}
            onChange={props.handleSearchCheckChange(props.searchId)}
          />
        )}
      </div>
      <SearchInfo
        cursor={showDropdown ? 'pointer' : 'auto'}
        onClick={() =>
          showDropdown &&
          (dropdownOpen
            ? props.closeDropdownForSearch(props.searchId)
            : props.openDropdownForSearch(props.searchId))
        }
      >
        <div style={{ paddingLeft: 16 }}>{props.searchType}</div>
        <div>{props.dateOrdered}</div>
        {props.status && <StatusLabel status={props.status} />}
        <div>{props.fee > 0 && `$${props.fee}`}</div>
        <div>
          {showDropdown && <DownCarotIcon style={dropdownOpen ? { transform: 'rotate(180deg' } : {}} />}
        </div>
      </SearchInfo>
      <DropdownOuter height={dropdownOpen ? '90px' : '0'}>
        {dropdownOpen && (
          <SearchActionsDropdown
            download={() => props.download(props)}
            searchType={props.searchType}
            status={props.status}
            updateSearch={note => {
              props.updateSearch({ id: props.searchTypeId, type: `${props.searchType} ${props.searchType.includes('Tax') ? 'Contin' : 'Update'}` }, note);
            }}
            viewPdf={() => viewPdf(`/api/utility/getDocument/${searchDocId}`)}
            sdaOpen={props.sdaOpen}
            downloadSda={props.downloadSda}
          />
        )}
      </DropdownOuter>
    </div>
  );
};

export default SearchCard;
